module.exports = __webpack_public_path__ + "static/media/user.1e6fb4ed.svg";